import React from "react";
import {
  Business,
  Person,
  CalendarToday,
  MonetizationOn,
  Public,
} from "@mui/icons-material";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import ActionButton from "../utils/ActionButton";

const companies = [
  {
    "S.no:": "3",
    "MLM Company Name": "Nu Skin",
    Founder: "Blake Roney, Sandie Tillotson",
    "Year Founded": "1984",
    Headquarter: "Provo, Utah",
    Industry: "Skincare, anti-aging products, nutritional supplements",
    "Revenue  2023": "$1.9 Billion",
    "Company Size": "1,000-5,000 employees",
    Website: "www.nuskin.com",
    logo: "/img/mlm_logos/logo10.webp",
  },
  {
    "S.no:": "4",
    "MLM Company Name": "Young Living",
    Founder: "D. Gary Young",
    "Year Founded": "1993",
    Headquarter: "Lehi, Utah",
    Industry: "Essential oils, wellness products",
    "Revenue  2023": "$213.7 Million",
    "Company Size": "1,001-5,000 employees",
    Website: "www.youngliving.com",
    logo: "/img/mlm_logos/logo17.webp",
  },
  {
    "S.no:": "6",
    "MLM Company Name": "USANA Health Sciences",
    Founder: "Myron Wentz",
    "Year Founded": "1992",
    Headquarter: "Salt Lake City, Utah",
    Industry: "Nutritional supplements, health and wellness products",
    "Revenue  2023": "$921 Million",
    "Company Size": "501-1000 employees",
    Website: "www.usana.com",
    logo: "/img/mlm_logos/logo16.webp",
  },
  {
    "S.no:": "7",
    "MLM Company Name": "Arbonne International",
    Founder: "Petter Morck",
    "Year Founded": "1975",
    Headquarter: "Utah",
    Industry: "Nutrition, skin care, cosmetics",
    "Revenue  2023": "$700 Million",
    "Company Size": "201-500 employees",
    Website: "www.arbonne.com",
    logo: "/img/mlm_logos/logo1.webp",
  },
  {
    "S.no:": "8",
    "MLM Company Name": "Morinda",
    Founder: "Kelly Olsen",
    "Year Founded": "1996",
    Headquarter: "Provo, Utah",
    Industry: "Dietary supplements, personal care products, and essential oils",
    "Revenue  2023": "$500 Million",
    "Company Size": "201-500 employees",
    Website: "www.morinda.com",
    logo: "/img/mlm_logos/logo8.webp",
  },
  {
    "S.no:": "9",
    "MLM Company Name": "Nature's Sunshine",
    Founder: "Gene Hughes",
    "Year Founded": "1972",
    Headquarter: "Lehi, Utah",
    Industry: "Health and wellness products, dietary supplements",
    "Revenue  2023": "$445 Million",
    "Company Size": "1,001-5,000 employees",
    Website: "www.naturessunshine.com",
    logo: "/img/mlm_logos/logo9.webp",
  },
  {
    "S.no:": "10",
    "MLM Company Name": "Plexus Worldwide",
    Founder: "Tarl Robinson & Alec Clark",
    "Year Founded": "2008",
    Headquarter: "Utah",
    Industry: "Weight management and wellness products",
    "Revenue  2023": "$377 Million",
    "Company Size": "10,000+ employees",
    Website: "www.plexusworldwide.com",
    logo: "/img/mlm_logos/logo11.webp",
  },
  {
    "S.no:": "11",
    "MLM Company Name": "Younique",
    Founder: "Derek Maxfield, Melanie Huscroft",
    "Year Founded": "2012",
    Headquarter: "Lehi, Utah",
    Industry: "Cosmetics, makeup products",
    "Revenue  2023": "$368 Million",
    "Company Size": "501-1000 employees",
    Website: "www.youniqueproducts.com",
    logo: "/img/mlm_logos/uniqueLogo.webp",
  },
  {
    "S.no:": "12",
    "MLM Company Name": "LIfeVantage",
    Founder: "Darren Jensen",
    "Year Founded": "2003",
    Headquarter: "Salt Lake City, Utah",
    Industry:
      "Weight loss products, wellness, skincare, energy-related products",
    "Revenue  2023": "$213 Million",
    "Company Size": "51-200 employees",
    Website: "www.lifevantage.com",
    logo: "/img/mlm_logos/logo5.webp",
  },
  {
    "S.no:": "13",
    "MLM Company Name": "Monat Global",
    Founder: "Rayner Urdaneta",
    "Year Founded": "2014",
    Headquarter: "Utah",
    Industry: "Hair care, skin care, wellness products",
    "Revenue  2023": "$210 Million",
    "Company Size": "",
    Website: "www.monatglobal.com",
    logo: "/img/mlm_logos/logo7.webp",
  },
  {
    "S.no:": "14",
    "MLM Company Name": "ASEA",
    Founder: "Verdis Norton, James Pack, Tyler Norton",
    "Year Founded": "2007",
    Headquarter: "Pleasant Groove, Utah",
    Industry: "Wellness products, nutritional supplements",
    "Revenue  2023": "$160 Million",
    "Company Size": "",
    Website: "www.aseaglobal.com",
    logo: "/img/mlm_logos/logo2.webp",
  },
  {
    "S.no:": "15",
    "MLM Company Name": "Zija International",
    Founder: "Ken Brailsford",
    "Year Founded": "2003",
    Headquarter: "Lehi, Utah",
    Industry: "Nutrition, wellness products",
    "Revenue  2023": "$136 Million",
    "Company Size": "1,001-5,000 employees",
    Website: "www.zijainternational.com",
    logo: "/img/mlm_logos/logo19.webp",
  },
  {
    "S.no:": "16",
    "MLM Company Name": "Synergy Worldwide",
    Founder: "Dan Higginson",
    "Year Founded": "1996",
    Headquarter: "Pleasant Grove, Utah",
    Industry: "Health and wellness products",
    "Revenue  2023": "$75 Million",
    "Company Size": "501-1000 employees",
    Website: "www.synergyworldwide.com",
    logo: "/img/mlm_logos/logo15.webp",
  },
  {
    "S.no:": "17",
    "MLM Company Name": "Modere",
    Founder: "Leslie Mower & Thomas Mower",
    "Year Founded": "1992",
    Headquarter: "Springville, Utah",
    Industry: "Health and wellness, personal care, home care",
    "Revenue  2023": "$70 Million",
    "Company Size": "201-500 employees",
    Website: "www.modere.com",
    logo: "/img/mlm_logos/logo6.webp",
  },
  {
    "S.no:": "18",
    "MLM Company Name": "Rain International",
    Founder: "Byron Belka",
    "Year Founded": "2009",
    Headquarter: "Orem, Utah",
    Industry: "Health and wellness, nutritional supplements",
    "Revenue  2023": "$35 Million",
    "Company Size": "501-1000 employees",
    Website: "www.rainintl.com",
    logo: "/img/mlm_logos/logo13.webp",
  },
  {
    "S.no:": "19",
    "MLM Company Name": "Zrii",
    Founder: "Bill Farley",
    "Year Founded": "2008",
    Headquarter: "Draper, Utah",
    Industry: "Wellness products, nutritional supplements",
    "Revenue  2023": "$21 Million",
    "Company Size": "",
    Website: "www.zrii.com",
    logo: "/img/mlm_logos/logo20.webp",
  },
  {
    "S.no:": "20",
    "MLM Company Name": "SeneGence",
    Founder: "Joni Rogers-Kante",
    "Year Founded": "1998",
    Headquarter: "USA",
    Industry: "Skin care, cosmetics, wellness and fitness products",
    "Revenue  2023": "$20.8 Million",
    "Company Size": "51-200 employees",
    Website: "www.senegence.com",
    logo: "/img/mlm_logos/logo14.webp",
  },
  {
    "S.no:": "21",
    "MLM Company Name": "Q Sciences",
    Founder: "Daren Hogge",
    "Year Founded": "2010",
    Headquarter: "American Fork, Utah",
    Industry: "Wellness products, nutritional supplements",
    "Revenue  2023": "$7.5 Million",
    "Company Size": "501-1000 employees",
    Website: "www.qsciences.com",
    logo: "/img/mlm_logos/logo12.webp",
  },
  {
    "S.no:": "5",
    "MLM Company Name": "do Terra ",
    Founder:
      "David Stirling, Gregory P. Cook, Corey B. Lindley, Emily Wright, Dr. David K. Hill, Mark A. Wolfert & Robert J. Young",
    "Year Founded": "2008",
    Headquarter: "Pleasant Groove, Utah",
    Industry: "Essential oils, personal care, wellness products",
    "Revenue  2023": "$1.5 Billion",
    "Company Size": "1,001-5,000 employees",
    Website: "www.doterra.com",
    logo: "/img/mlm_logos/logo3.webp",
  },
];

const MLM = () => {
  const gotosite = (website) => {
    window.open(`https://${website}`, "_blank");
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <LandingSection
        data={{
          imageName: "mlm.webp",
          title: "MLM Companies in Utah",
          visible: "",
        }}
      />

      <div className="verticals_section">
        <div className="verticals-intro">
          <div className="verticals-intro-sec1">
            <h2>
              MLM Companies in <br /> Utah ({companies.length})
            </h2>
          </div>
          <div className="verticals-intro-sec2">
            <p>
              Utah is a hub for MLM (Multi-Level Marketing) companies, with many
              industry leaders headquartered in the state, benefiting from a
              supportive business climate and entrepreneurial culture.
            </p>

            {/* <ActionButton data="Explore More" /> */}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex justify-center">
        <main className="flex-grow container px-4 py-12">
          <div className="mb-8 text-center">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-900 mb-2">
              Featured MLM Companies ({companies.length})
            </h2>
            <p className="text-xl text-blue-700">
              Browse through the most successful multi-level marketing companies
            </p>
          </div>

          {/* Companies Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {companies.map((company, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl hover:shadow-[#014CB2] transition-shadow duration-300 cursor-pointer"
                onClick={() => gotosite(company.Website)}
              >
                {/* Logo */}
                <div
                  className={`bg-blue-100 p-4 flex items-center justify-center h-24`}
                >
                  <img
                    src={company.logo}
                    alt={company["MLM Company Name"]}
                    className={`h-full object-contain w-full`}
                  />
                </div>

                {/* Content */}
                <div className="p-6">
                  <div className="grid grid-cols-8">
                    {/* Founder */}

                    <div className="col-span-1 flex justify-center items-center mb-2">
                      <Person className="text-gray-500" />
                    </div>
                    <div className="col-span-7 mb-2">
                      <div className="grid grid-cols-12 gap-1 items-center">
                        <p className="col-span-4 text-sm font-semibold text-black mb-0">
                          {index === companies.length - 1
                            ? "Founders"
                            : "Founder"}
                        </p>
                        <p className="col-span-8 text-gray-800 mb-0">
                          {company.Founder}
                        </p>
                      </div>
                    </div>

                    {/* Year Founded */}
                    <div className="col-span-1 flex justify-center items-center mb-2">
                      <CalendarToday className="text-gray-500" />
                    </div>
                    <div className="col-span-7 mb-2">
                      <div className="grid grid-cols-12 gap-1 items-center">
                        <p className="col-span-4 text-sm font-semibold text-black mb-0">
                          Year:
                        </p>
                        <p className="col-span-8 text-gray-800 mb-0">
                          {company["Year Founded"]}
                        </p>
                      </div>
                    </div>

                    {/* Industry */}
                    <div className="col-span-1 flex justify-center items-center mb-2">
                      <Business className="text-gray-500" />
                    </div>
                    <div className="col-span-7 mb-2">
                      <div className="grid grid-cols-12 gap-1 items-center">
                        <p className="col-span-4 text-sm font-semibold text-black mb-0">
                          Industry:
                        </p>
                        <p className="col-span-8 text-gray-800 mb-0">
                          {company.Industry}
                        </p>
                      </div>
                    </div>

                    {/* Revenue */}
                    <div className="col-span-1 flex justify-center items-center mb-2">
                      <MonetizationOn className="text-gray-500" />
                    </div>
                    <div className="col-span-7 mb-2">
                      <div className="grid grid-cols-12 gap-1 items-center">
                        <p className="col-span-4 text-sm font-semibold text-black mb-0">
                          Revenue:
                        </p>
                        <p className="col-span-8 text-green-600 font-semibold mb-0">
                          {company["Revenue  2023"] || "N/A"}
                        </p>
                      </div>
                    </div>

                    {/* Headquarters */}
                    <div className="col-span-1 flex justify-center items-center mb-2">
                      <Public className="text-gray-500" />
                    </div>
                    <div className="col-span-7 mb-2">
                      <div className="grid grid-cols-12 gap-1 items-center">
                        <p className="col-span-4 text-sm font-semibold text-black mb-0">
                          HQ:
                        </p>
                        <p className="col-span-8 text-gray-800 mb-0">
                          {company.Headquarter}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Data Sources */}
          <div className="mt-12 text-right">
            <p className="font-semibold mb-2 text-sm">Data Sources:</p>
            <div className="flex flex-col items-end gap-1">
            <a
              href="https://www.globalmlmsolution.com/blog/top-mlm-companies-in-utah#List-of-MLM-Companies-in-Utah"
              className="text-blue-600 hover:underline text-sm"
              target="_blank"
              rel="noopener noreferrer"
            >
              Global MLM Solution
            </a>
            <a
              href="https://www.plerdy.com/blog/top-multi-level-marketing-companies/"
              className="text-blue-600 hover:underline text-sm"
              target="_blank"
              rel="noreferrer"
            >
              Plerdy - Top MLM Companies
            </a>
            <a
              href="https://infinitemlmsoftware.com/blog/top-mlm-companies-in-utah/"
              className="text-blue-600 hover:underline text-sm"
              target="_blank"
              rel="noreferrer"
            >
              Infinite MLM Software
            </a>
          </div>
          </div>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default MLM;
